// Shown after scan — report auto-emailed to guest.

import React, { useEffect, useState } from 'react';
import logoSrc from '../../assets/mywellfie-header-logo.png';
import './landing.css';

interface Props {
  email: string;
  guestName?: string;
  onReturn: () => void;
  resetSeconds?: number;
}

const AdhocEmailSuccessStage: React.FC<Props> = ({
  email,
  guestName,
  onReturn,
  resetSeconds = 30,
}) => {
  const [remaining, setRemaining] = useState(resetSeconds);
  const greeting = guestName?.trim() ? `All done, ${guestName.trim()}!` : 'All done!';

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining((r) => Math.max(0, r - 1));
    }, 1000);
    const timeout = setTimeout(onReturn, resetSeconds * 1000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onReturn, resetSeconds]);

  return (
    <div className="adhoc-landing" style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <nav>
        <div className="wrap">
          <div className="nav-logo">
            <img src={logoSrc} alt="MyWellfie" />
          </div>
        </div>
      </nav>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px 32px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: '#ECFDF5',
            border: '1px solid #A7F3D0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 32,
            marginBottom: 24,
            color: '#059669',
          }}
        >
          ✓
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
            fontWeight: 700,
            color: 'var(--ink)',
            margin: '0 0 12px',
          }}
        >
          {greeting}
        </h1>
        <p style={{ color: 'var(--muted)', fontSize: 17, maxWidth: 440, margin: '0 0 8px', lineHeight: 1.6 }}>
          Your full health report has been sent to
        </p>
        <p
          style={{
            color: 'var(--ink)',
            fontSize: 17,
            fontWeight: 700,
            margin: '0 0 28px',
            wordBreak: 'break-word',
          }}
        >
          {email}
        </p>
        <p style={{ color: 'var(--muted)', fontSize: 15, maxWidth: 400, margin: '0 0 24px', lineHeight: 1.6 }}>
          Save this scan to your dashboard and track your health over time.
        </p>
        <a
          href={`/app/signup?email=${encodeURIComponent(email)}`}
          className="btn btn-offer"
          style={{ marginBottom: 16 }}
        >
          Create free account
          <span className="btn-arrow" aria-hidden>→</span>
        </a>
        <p style={{ color: 'var(--muted)', fontSize: 14, maxWidth: 400, margin: '0 0 24px', lineHeight: 1.6 }}>
          Returning to the home page in {remaining} second{remaining !== 1 ? 's' : ''}…
        </p>
        <button type="button" className="btn btn-ghost" onClick={onReturn}>
          Back to home now
        </button>
      </div>
    </div>
  );
};

export default AdhocEmailSuccessStage;
